<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import { init } from '@/util/util';
  export default {
    name: 'app',
    data () {
      return {

      }
    },
    created(){
      init();
    },
    mounted(){
    },
    methods: {

    },
  };

</script>



// WEBPACK FOOTER //
// src/App.vue